import React from 'react';
import Spinner from 'react-spinkit';
import padding from 'scy/padding.mod.scss';
import margin from 'scy/margin.mod.scss';
import { textCenter } from 'scy/utils.mod.scss';
import { Body, Paragraph } from 'scy/text';

export default function Description({
  description,
  description_html,
  loading
}) {
  if (loading) {
    return (
      <div
        className={`${padding.md} ${margin.bottom_sm} ${textCenter} ${
          margin.tablet_right_xl
        }`}
      >
        <Spinner spinnerName="three-bounce" />
      </div>
    );
  }

  if (description_html) {
    return (
      <Body
        marginClass={`${margin.top_0} ${margin.bottom_sm}`}
        dangerouslySetInnerHTML={{ __html: description_html }}
      />
    );
  }

  return (
    <Paragraph
      marginClass={`${margin.top_0} ${margin.bottom_sm}`}
      dangerouslySetInnerHTML={{
        __html: (description || '').replace(/[\r\n]/g, '<br />')
      }}
    />
  );
}
